import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'wz-souscription-error',
  templateUrl: './souscription-error.component.html',
  styleUrls: ['./souscription-error.component.scss'],
})
export class SouscriptionErrorComponent implements AfterViewInit, OnDestroy {
  description: string;
  title: string;
  intervNam: any;
  // popuError: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<SouscriptionErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataErrorSouqcription,
    private router: Router,
  ) {
    this.description = this.data.description;
    this.title = this.data.title;
    this.showDateError();

    this.intervNam = setInterval(() => {
      this.updateByJS();
    }, 10);
  }
  ngOnDestroy(): void {
    clearInterval(this.intervNam);
  }

  ngAfterViewInit(): void {
    this.updateByJS();
  }

  ngAfterViewChecked() {
    this.updateByJS();
  }

  ngAfterContentChecked() {
    this.updateByJS();
  }

  ngAfterContentInit() {
    this.updateByJS();
  }

  updateByJS(): void {
    let e = document.querySelector("[data-message='description']");
    if (e)
      e.innerHTML =
        this.description == 'La date de début de contrat souhaitée est passé'
          ? 'La date de début de contrat souhaitée est passé.'
          : 'Le service est momentanément indisponible.';
    let et = document.querySelector("[data-title='title']");
    if (et) et.innerHTML = this.title;
  }

  closeErrorIntern() {
    this.router.navigate(['/demande-devis']);
    this.dialogRef.close();
  }

  showDateError(): boolean {
    //   debugger;
    const isErrors =
      this.description == 'La date de début de contrat souhaitée est passé';
    this.description = isErrors
      ? 'La date de début de contrat souhaitée est passé'
      : 'Le service est momentanément indisponible';
    this.updateByJS();
    return isErrors;
  }
}

export interface DataErrorSouqcription {
  description: string;
  title: string;
}
